import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Pivot, PivotSetupForm } from "../dtos/pivot";

const DUMMY_PIVOTS: Pivot[] = [
  {
    id: 1,
    name: "Pivot 1 - North Field",
    serial: 10001,
    length: 2640,
    description: "Primary irrigation circle for the north quarter.",
    status: "Running",
    anglePercent: 222,
    flow: 1285,
    pressure: 42,
    current: 31,
    online: true,
    lat: 34.40532965700312,
    lon: -102.46304102826352,
    pivot_type: "partial",
    travel_direction: "CCW",
    speed_percent: 78,
    limit_angle_a: 180,
    limit_angle_b: 0,
    limit_a_action: "reverse",
    limit_b_action: "stop",
    end_gun_enabled: true,
    end_gun_sections: [
      { name: "North Corner", limit_angle_1: 52, limit_angle_2: 78, enabled: true },
      { name: "Shop Approach", limit_angle_1: 198, limit_angle_2: 224, enabled: true }
    ],
    pump_ids: [1, 3],
    valve_ids: [1, 4],
    pump_locations: [
      { id: 1, name: "Pump 1", serialNumber: 20001, lat: 34.405548, lon: -102.462881 },
      { id: 3, name: "Pump 3", serialNumber: 20003, lat: 34.405611, lon: -102.463181 }
    ],
    valve_locations: [
      { id: 1, lat: 34.405409, lon: -102.462721 },
      { id: 4, lat: 34.405041, lon: -102.462921 }
    ]
  },
  {
    id: 2,
    name: "Pivot 2 - South Field",
    serial: 10002,
    length: 1320,
    description: "Full-circle unit covering the south field.",
    status: "Stopped",
    anglePercent: 0,
    flow: 0,
    pressure: 0,
    current: 0,
    online: true,
    lat: 34.4015095133014,
    lon: -102.44975584729065,
    pivot_type: "full",
    travel_direction: "CCW",
    speed_percent: 62,
    limit_angle_a: 0,
    limit_angle_b: 359,
    limit_a_action: "stop",
    limit_b_action: "stop",
    end_gun_enabled: true,
    end_gun_sections: [
      { name: "South Edge", limit_angle_1: 188, limit_angle_2: 214, enabled: true },
      { name: "Lane Crossing", limit_angle_1: 304, limit_angle_2: 326, enabled: true }
    ],
    pump_ids: [2, 5],
    valve_ids: [2, 5],
    pump_locations: [
      {
        id: 2, name: "Pump 2", serialNumber: 20002,
        lat: 34.399200,
        lon: -102.446446
      },
      {
        id: 5, name: "Pump 5", serialNumber: 20005,
        lat: 34.398240,
        lon: -102.446446
      }
    ],
    valve_locations: [
      { id: 2, lat: 34.401569, lon: -102.449362 },
      { id: 5, lat: 34.401224, lon: -102.449664 }
    ]
  },
  // big fields: 
  // 34.40479934974336, -102.43689026857466
  // 34.41946758650962, -102.45393963307424
  // 
  {
    id: 3,
    name: "Pivot 3 - East Field",
    serial: 10003,
    length: 2640,
    description: "East field backup pivot.",
    status: "Idle",
    anglePercent: 270,
    flow: 220,
    pressure: 18,
    current: 9,
    online: false,
    lat: 34.40492785105454,
    lon: - 102.43677950364314,
    pivot_type: "partial",
    travel_direction: "CW",
    speed_percent: 55,
    limit_angle_a: 110,
    limit_angle_b: 320,
    limit_a_action: "stop",
    limit_b_action: "reverse",
    end_gun_enabled: true,
    end_gun_sections: [],
    pump_ids: [1, 4],
    valve_ids: [3],
    pump_locations: [
      {
        id: 1,
        name: "Pump 1",
        serialNumber: 20001,
        lat: 34.399488,
        lon: -102.453840
      },
      {
        id: 4,
        name: "Pump 4",
        serialNumber: 20004,
        lat:
          34.399046,
        lon: -102.453582
      }
    ],
    valve_locations: [
      { id: 3, lat: 34.404807, lon: -102.436442 }
    ]
  },
  {
    id: 4,
    name: "Pivot 4 - West Field",
    serial: 10004,
    length: 1320,
    description: "Longest run on the west side.",
    status: "Running",
    anglePercent: 85,
    flow: 1540,
    pressure: 47,
    current: 36,
    online: true,
    lat: 34.40900848317212,
    lon: -102.45817260611261,
    pivot_type: "full",
    travel_direction: "CW",
    speed_percent: 90,
    limit_angle_a: 0,
    limit_angle_b: 359,
    limit_a_action: "stop",
    limit_b_action: "stop",
    end_gun_enabled: true,
    end_gun_sections: [
      { name: "Roadside", limit_angle_1: 258, limit_angle_2: 282, enabled: false },
      { name: "West Ditch", limit_angle_1: 332, limit_angle_2: 348, enabled: true }
    ],
    pump_ids: [3, 4, 5],
    valve_ids: [1, 2, 4],
    pump_locations: [
      {
        id: 3,
        name: "Pump 3",
        serialNumber: 20003,
        lat: 34.398892,
        lon: -102.443701
      },
      {
        id: 4, name: "Pump 4",
        serialNumber: 20004,
        lat: 34.412323,
        lon: -102.453955
      },
      {
        id: 5,
        name: "Pump 5",
        serialNumber: 20005,
        lat: 34.412151,
        lon: -102.454866
      }
    ],
    valve_locations: [
      { id: 1, lat: 34.409091, lon: -102.457791 },
      { id: 2, lat: 34.408712, lon: -102.458053 },
      { id: 4, lat: 34.409012, lon: -102.458614 }
    ]
  },
];

let nextId = DUMMY_PIVOTS.length + 1;
let pivotsStore: Pivot[] = DUMMY_PIVOTS;
const listeners = new Set<Dispatch<SetStateAction<Pivot[]>>>();

const broadcast = () => {
  listeners.forEach(listener => listener([...pivotsStore]));
};

export const usePivots = () => {
  const [pivots, setPivots] = useState<Pivot[]>(pivotsStore);

  useEffect(() => {
    listeners.add(setPivots);
    return () => {
      listeners.delete(setPivots);
    };
  }, []);

  const addPivot = (form: PivotSetupForm) => {
    const newPivot: Pivot = {
      id: nextId++,
      name: form.name,
      serial: form.serial,
      length: form.length_ft,
      status: "Idle",
      anglePercent: 0,
      flow: 0,
      pressure: 0,
      current: 0,
      online: false,
      lat: form.center_lat ?? undefined,
      lon: form.center_lon ?? undefined,
      description: form.description,
      pivot_type: form.pivot_type,
      travel_direction: form.travel_direction,
      speed_percent: form.speed_percent,
      limit_angle_a: form.limit_angle_a,
      limit_angle_b: form.limit_angle_b,
      limit_a_action: form.limit_a_action,
      limit_b_action: form.limit_b_action,
      end_gun_enabled: form.end_gun_enabled,
      end_gun_sections: form.end_gun_sections,
      pump_ids: form.pump_ids,
      valve_ids: form.valve_ids,
      pump_locations: [],
      valve_locations: []
    };
    pivotsStore = [...pivotsStore, newPivot];
    broadcast();
  };

  const updatePivot = (updated: Pivot) => {
    pivotsStore = pivotsStore.map(p => p.id === updated.id ? updated : p);
    broadcast();
  };

  const removePivot = (id: number) => {
    pivotsStore = pivotsStore.filter(p => p.id !== id);
    broadcast();
  };

  return { pivots, addPivot, updatePivot, removePivot };
};
